import PropTypes from 'prop-types';
import CarItinerary from '../../../../TravelOption/CarsInformation/CarItinerary';
import CarItineraryInfo from '../../../../TravelOption/CarsInformation/CarItinerary/CarItineraryInfo/index.tsx';

const CarCompareTable = ({ carTravelOptions, doShowViewButtonColumn, doShowPrice }) =>
  carTravelOptions &&
  carTravelOptions.map((travelOption) =>
    doShowViewButtonColumn ? (
      <CarItinerary
        itinerary={travelOption.carItinerary}
        key={travelOption.itineraryId}
        doShowPrice={doShowPrice}
      />
    ) : (
      <div className="my-3 rounded-lg sm:p-3 p-2 border-2" key={travelOption.itineraryId}>
        <CarItineraryInfo
          itinerary={travelOption.carItinerary}
          doParseEmailTemplate
          doShowPrice={doShowPrice}
        />
      </div>
    ),
  );

CarCompareTable.propTypes = {
  carTravelOptions: PropTypes.arrayOf(PropTypes.objectOf).isRequired,
  doShowViewButtonColumn: PropTypes.bool,
  doShowPrice: PropTypes.bool,
};

CarCompareTable.defaultProps = {
  doShowViewButtonColumn: true,
  doShowPrice: true,
};

export default CarCompareTable;
